export default __webpack_public_path__ + "static/media/icon-tailed-arrow-up.b9bab48a.svg";